import { render, staticRenderFns } from "./SafetyConfirmsTable.vue?vue&type=template&id=3c254efd&scoped=true&lang=pug"
import script from "./SafetyConfirmsTable.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmsTable.vue?vue&type=script&lang=ts"
import style0 from "./SafetyConfirmsTable.vue?vue&type=style&index=0&id=3c254efd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c254efd",
  null
  
)

export default component.exports